/*
 * @Description: 分区模板
 * @Author: gao shuai
 * @Date: 2020-02-25 15:36:33
 * @LastEditTime: 2020-06-27 11:00:28
 * @LastEditors: gao shuai
 */
import api from '../services/api';
export default {
  // 分区分页模板列表
  async getTemplateList(params) { return api({ url: '/api/PartitionsTemplates/GetPartitionsTemplatesListAsync', method: 'get', params }); },
  // 充值赠送状态切换
  async giveSwith(params) { return api({ url: '/api/PartitionsTemplates/OffOnStateAsync', method: 'post', data: params }); },
  // 删除分区模板
  async deleteModule(params) { return api({ url: '/api/PartitionsTemplates/PartitionsTemplatesDeleteAsync', method: 'post', data: params }); },
  // 获取模板的详情信息
  async moduleDetail(params) { return api({ url: '/api/PartitionsTemplates/GetTemplateDetail', method: 'get', params }); },
  // 编辑模板
  async editModule(params) { return api({ url: '/api/Template/EditTemplate', method: 'post', data: params }); },
  // 添加时获取充值渠道的产品
  async getproduct(params) { return api({ url: '/api/Template/GetProducts', method: 'get', params }); },
  // 添加模板
  async addModule(params) { return api({ url: '/api/Template/AddTemplate', method: 'post', data: params }); },
  // 游戏引擎下拉
  async gameEnginedrow(params) { return api({ url: '/api/Template/GetEngineList', method: 'get', params }); },
  // 克隆template
  async cloneModule(params) { return api({ url: '/api/Template/CloneTemplate', method: 'post', data: params }); }
};
